
import { loginAuthor } from '@/api/api.js'
function getUrlParams (name, url) {
  const u = arguments[1] || window.location.href
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  const r = u.substr(u.indexOf('?') + 1).match(reg)
  console.log(url)
  return r != null ? decodeURIComponent(r[2]) : ''
}
function getBaseUrl () {
  let baseURL = ''
  if (!window.location.origin) {
      window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
  } else {
      baseURL = window.location.origin
  }
  return baseURL
}
export const loginIn = () => {
  const redirect_uri = getUrlParams('redirect_uri', window.location.href)
  const obj = {}
  if (!redirect_uri) {
    obj.redirect_uri = window.encodeURIComponent(window.location.href)
  }
  let queryParams = ''
  for (const i in obj) queryParams = '?' + i + '=' + obj[i]
  loginAuthor({redirect_uri: getBaseUrl() + '/login' + queryParams}).then(res => {
      if (res.data.code ==0) {
          window.open(res.data.msg.url, '_self')
      }
  })
  // window.open(params.url + queryParams, '_self')
}
export const loginOut = () => {
  window.sessionStorage.clear();
  window.localStorage.clear();
  const logoutUrl = process.env.NODE_ENV === 'production' ? 'https://sso.hgcitech.com/cas/HGCi/91aioc/logout': 'https://sso.hgcitech.com/cas/HGCi/91aioc/logout'
  window.location.href = logoutUrl + '?service='+ getBaseUrl()
}



// WEBPACK FOOTER //
// ./src/utils/loginIn.js